import {styled} from "styled-components";

const BubbleBase = styled.div`
  padding: 0.5rem 0.75rem;
  word-wrap: break-word;
  overflow-x: auto;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  user-select: text;
`;

export const ChatBubbleLeft = styled(BubbleBase)`
  background: var(--ion-color-light);
  color: var(--ion-color-light-contrast);
  border-radius: 0.75rem 0.75rem 0.75rem 0;
`;

export const ChatBubbleRight = styled(BubbleBase)`
  background: var(--ion-color-primary-light);
  color: var(--ion-color-primary-light-contrast);
  border-radius: 0.75rem 0.75rem 0 0.75rem;
`;

const MessageRowBase = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 0.25rem;
  max-width: 95%;
  margin: 0.25rem 0;
`;

export const MessageRowLeft = styled(MessageRowBase)`
  align-self: flex-start;
`;

export const MessageRowRight = styled(MessageRowBase)`
  align-self: flex-end;
`;

export const Avatar = styled.div`
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: var(--ion-color-light);
  color: var(--ion-color-light-contrast);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  flex-shrink: 0;
`;

export const SystemMessage = styled.div`
  align-self: center;
  color: var(--ion-color-medium);
  font-style: italic;
  font-size: 0.85rem;
  text-align: center;
  padding: 6px 0;
`;

export const MessageTime = styled.div`
  font-size: 0.7rem;
  margin-top: 4px;
  opacity: 0.7;
`;

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0 1rem;
`;

export const getInitials = (name: string) => {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};
